// extracted by mini-css-extract-plugin
export default {"container":"mes_2AmkD","messages":"mes_mes_3rUZr","message":"mes_mes_1Nw_"};